/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summer_Unoccupied_SetpointInputs */



/**
* | output |
* | --- |
* | "Summer unoccupation setpoint" |
*
* @param {Summer_Unoccupied_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const summer_unoccupied_setpoint = /** @type {((inputs?: Summer_Unoccupied_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summer_Unoccupied_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer unoccupation setpoint")
	return /** @type {LocalizedString} */ ("Consigne inoccupation été")
});